export const SET_RIDE = 'SET_RIDE'
